import script from "./AppStore.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStore.vue?vue&type=script&setup=true&lang=js"

import "./AppStore.vue?vue&type=style&index=0&id=23c2c182&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c2c182"]])

export default __exports__